import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Loader2 } from "lucide-react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import EditorPage from "./pages/EditorPage";
import PricingPage from "./pages/PricingPage";
import AdminPage from "./pages/AdminPage";
import MediaLibraryPage from "./pages/MediaLibraryPage";
import LoginPage from "./pages/LoginPage";
import { AuthProvider, useAuth } from "./lib/auth";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Protected = ({ children, adminOnly = false }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) {
    return (
      <div className="min-h-screen bg-[#FFF7F0] flex items-center justify-center gap-2 text-[#8A7F73] font-bold text-[14px]">
        <Loader2 size={18} className="animate-spin text-[#F26F21]" /> Comprobando sesión…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

const Shell = () => {
  const { pathname } = useLocation();
  const isLogin = pathname === "/login";
  return (
    <>
      <ScrollToTop />
      {!isLogin && <Header />}
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<Protected><HomePage /></Protected>} />
        <Route path="/editor" element={<Protected><EditorPage /></Protected>} />
        <Route path="/upload" element={<Protected><EditorPage /></Protected>} />
        <Route path="/tarifas" element={<Protected><PricingPage /></Protected>} />
        <Route path="/pricing" element={<Protected><PricingPage /></Protected>} />
        <Route path="/mediateca" element={<Protected><MediaLibraryPage /></Protected>} />
        <Route path="/admin" element={<Protected adminOnly><AdminPage /></Protected>} />
      </Routes>
      {!isLogin && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Shell />
          <Toaster position="bottom-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
